import React, { useState } from 'react';
import SubNavbar from '../../components/SubNavbar';
import PhotoModal from '../../components/PhotoModal';

const USVarious = () => {
  const [modalImage, setModalImage] = useState(null);
  const [modalAlt, setModalAlt] = useState('');

  const openModal = (imageSrc, imageAlt) => {
    setModalImage(imageSrc);
    setModalAlt(imageAlt);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAlt('');
  };

  return (
    <div className="white-page">
      <SubNavbar />
      <div className="photography-subpage-content">
        <div className="photos-container">
          <div className="photo-grid">
            <div className="photo-item large">
              <img 
                src="/photos/PBFamily.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/PBFamily.jpg", "Family at Panther Bay")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/ChicagoLibrary.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/ChicagoLibrary.jpg", "Chicago Library Exterior")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/Library.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/Library.jpg", "Library View")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item tall">
              <img 
                src="/photos/RiverwalkChicagoPortrait.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/RiverwalkChicagoPortrait.jpg", "Chicago Riverwalk Portrait")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item large">
              <img 
                src="/photos/ChicagoLibraryInside.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/ChicagoLibraryInside.jpg", "Chicago Library Interior")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item large">
              <img 
                src="/photos/MountainAsheville.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/MountainAsheville.jpg", "Mountain View in Asheville")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/SCPier.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/SCPier.jpg", "Santa Cruz Pier")}
                style={{ cursor: 'pointer' }}
              />
            </div>



            <div className="photo-item">
              <img 
                src="/photos/ChicagoLighthouse.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/ChicagoLighthouse.jpg", "Chicago Lighthouse")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/DowntownParkDallas.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/DowntownParkDallas.jpg", "Downtown Park Dallas")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/AshevilleBackyard.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/AshevilleBackyard.jpg", "Backyard in Asheville")}
                style={{ cursor: 'pointer' }}
              />
            </div>

            <div className="photo-item">
              <img 
                src="/photos/UTDCampus_1.jpg" 
                loading="lazy" 
                onClick={() => openModal("/photos/UTDCampus_1.jpg", "UTD Campus")}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="photo-item">
              <img 
                src="/photos/Duster.JPG" 
                loading="lazy" 
                onClick={() => openModal("/photos/Duster.JPG", "Duster")}
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
        </div>
      </div>
      <PhotoModal 
        isOpen={modalImage !== null}
        imageSrc={modalImage}
        imageAlt={modalAlt}
        onClose={closeModal}
      />
    </div>
  );
};

export default USVarious;
